var _defs, _polygon, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullLayout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "office-layout",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 980 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      /* Base stroke styles */\n      .base-stroke {\n        stroke: #0e1834;\n        stroke-miterlimit: 10;\n        stroke-width: 0.25px;\n      }\n      \n      .thick-stroke {\n        stroke: #231815;\n        stroke-miterlimit: 10;\n        stroke-width: 0.5px;\n      }\n      \n      .heavy-stroke {\n        stroke: #231815;\n        stroke-miterlimit: 10;\n        stroke-width: 0.75px;\n      }\n      \n      .door-stroke {\n        stroke: #828282;\n        stroke-miterlimit: 10;\n        stroke-width: 0.25px;\n        fill: none;\n      }\n      \n      .line-stroke {\n        stroke: #818182;\n        stroke-miterlimit: 10;\n        stroke-width: 0.25px;\n        fill: #fff;\n      }\n      \n      .interactive-area {\n        stroke: #18305f !important;\n        fill: none;\n        cursor: pointer;\n      }\n      \n      /* Team area colors */\n      .team1 { fill: #fdede9 !important; }\n      .team2 { fill: #e7f2e0 !important; }\n      .team3 { fill: #feefdd !important; }\n      .team4 { fill: #e1f2fb !important; }\n      .team5 { fill: #dfe3f3 !important; }\n      .team6 { fill: #e8f8f5 !important; }\n      .team7 { fill: #fefae6 !important; }\n      .ceo-office { fill: #f9d4d4 !important; }\n      .senior-exec-office { fill: #def0ea !important; }\n      .executive-office { fill: #f6e6f0 !important; }\n      .meeting-room { fill: #fff; }\n      .none { fill: white; }\n      \n      /* Team5 \uC138\uBD80 \uD300 \uC0C9\uC0C1 */\n      .businessSupport-seat { fill: #f0fff7 !important; } /* \uACBD\uC601\uC9C0\uC6D0\uD300 - \uC5F0\uD55C \uBBFC\uD2B8\uC0C9 */\n      .financeTeam-seat { fill: #fff0eb !important; }     /* \uC7AC\uBB34\uD68C\uACC4\uD300 - \uC5F0\uD55C \uC0B4\uAD6C\uC0C9 */\n      \n      /* Team7 \uC138\uBD80 \uD300 \uC0C9\uC0C1 */\n      .media-team { fill: #fefae6 !important; }           /* \uBBF8\uB514\uC5B4\uC0AC\uC5C5\uD300 - \uC5F0\uD55C \uB178\uB780\uC0C9 */\n      .external-affairs-team { fill: #eef6ff !important; } /* \uB300\uC678\uC0AC\uC5C5\uD300 - \uC5F0\uD55C \uD30C\uB780\uC0C9 */\n      .licensing-team { fill: #fef0ef !important; }        /* \uC778\uD5C8\uAC00\uD300 - \uC5F0\uD55C \uD551\uD06C\uC0C9 */\n      \n      /* Text styles */\n      .room-label {\n        fill: #231815;\n        font-family: 'NanumSquare_acR', NanumSquare_ac;\n        font-size: 8px;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "thick-stroke meeting-room",
    points: "928.41 40.52 848 40.52 844.98 40.52 232.58 40.52 232.58 44.26 213.08 44.26 212.91 44.09 212.74 44.26 212.48 44.26 212.48 44.52 197.15 59.85 213.89 76.58 115.49 174.98 97.12 156.6 81.36 172.36 81.36 446.26 79.93 446.26 79.93 459.48 848 459.48 848 446.26 707.7 446.26 707.7 436.08 693.84 436.08 693.84 446.26 471.68 446.26 471.68 436.08 457.82 436.08 457.82 446.26 231.55 446.26 231.55 436.08 217.69 436.08 217.69 446.26 109.1 446.26 109.1 436.08 95.24 436.08 94.58 193.58 102.58 193.58 102.76 193.77 102.95 193.58 115.6 193.58 115.6 193.52 116.31 194.23 232.88 76.7 234.03 63.73 234.03 53.74 844.98 53.74 844.98 53.79 928.41 53.79 928.41 219.73 943.91 219.73 943.91 53.79 943.91 40.52 928.41 40.52"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "structural-elements"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "heavy-stroke meeting-room",
    x: 231.74,
    y: 232.47,
    width: 2.63,
    height: 63.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "heavy-stroke meeting-room",
    x: 231.77,
    y: 53.96,
    width: 2.63,
    height: 154.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "heavy-stroke meeting-room",
    x: 231.74,
    y: 320.22,
    width: 2.63,
    height: 125.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "heavy-stroke meeting-room",
    x: 294.21,
    y: 339.69,
    width: 2.63,
    height: 106.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "heavy-stroke meeting-room",
    x: 412.86,
    y: 339.69,
    width: 2.63,
    height: 106.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "heavy-stroke meeting-room",
    x: 516.99,
    y: 339.69,
    width: 2.63,
    height: 106.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "heavy-stroke meeting-room",
    x: 620.26,
    y: 339.69,
    width: 2.63,
    height: 106.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "heavy-stroke meeting-room",
    x: 234.5,
    y: 336.56,
    width: 32.65,
    height: 3.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "heavy-stroke meeting-room",
    x: 94.84,
    y: 241.42,
    width: 132.59,
    height: 1.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "heavy-stroke meeting-room",
    x: 234.5,
    y: 292.62,
    width: 94.68,
    height: 3.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "heavy-stroke meeting-room",
    x: 338.93,
    y: 181.31,
    width: 258.17,
    height: 3.13,
    transform: "translate(650.89 -285.14) rotate(90)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "heavy-stroke meeting-room",
    points: "448.47 287.33 448.47 292.62 359.94 292.62 359.94 295.75 451.6 295.75 451.6 292.62 451.6 287.33 448.47 287.33"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "heavy-stroke meeting-room",
    x: 290.51,
    y: 336.56,
    width: 10.49,
    height: 3.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "heavy-stroke meeting-room",
    x: 325.28,
    y: 336.56,
    width: 94.57,
    height: 3.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "heavy-stroke meeting-room",
    x: 443.49,
    y: 336.56,
    width: 79.7,
    height: 3.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "heavy-stroke meeting-room",
    x: 547.39,
    y: 336.56,
    width: 79.7,
    height: 3.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "heavy-stroke meeting-room",
    x: 650.83,
    y: 336.56,
    width: 150.93,
    height: 3.13
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "heavy-stroke meeting-room",
    points: "928.41 219.73 770.63 219.73 767.88 219.73 767.5 219.73 767.5 283.9 707.62 283.9 707.62 287.03 767.5 287.03 770.19 287.03 770.63 287.03 770.63 222.86 928.41 222.86 928.41 219.73"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "meeting-room base-stroke",
    x: 801.76,
    y: 53.79,
    width: 4.16,
    height: 133.87
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "info-panels"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "thick-stroke meeting-room",
    x: 485.69,
    y: 53.79,
    width: 205.88,
    height: 11.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "thick-stroke meeting-room",
    x: 539.23,
    y: 272.04,
    width: 90.77,
    height: 11.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "thick-stroke meeting-room",
    x: 668.02,
    y: 272.04,
    width: 22.72,
    height: 11.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "heavy-stroke meeting-room",
    x: 451.6,
    y: 270.95,
    width: 14.86,
    height: 16.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "thick-stroke meeting-room",
    x: 469.92,
    y: 272.04,
    width: 47.07,
    height: 11.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "thick-stroke meeting-room",
    x: 705.99,
    y: 53.79,
    width: 68.38,
    height: 11.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "thick-stroke meeting-room",
    x: 379.29,
    y: 281.46,
    width: 69.17,
    height: 11.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "thick-stroke meeting-room",
    x: 234.5,
    y: 281.46,
    width: 91.84,
    height: 11.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "heavy-stroke meeting-room",
    x: 690.74,
    y: 272.35,
    width: 16.89,
    height: 15.58
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "team2-desks"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "team2 base-stroke",
    x: 320.62,
    y: 53.7,
    width: 31.29,
    height: 46.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "team2 base-stroke",
    x: 320.62,
    y: 100.17,
    width: 31.29,
    height: 46.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "team2 base-stroke",
    x: 320.62,
    y: 146.68,
    width: 31.29,
    height: 46.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "team2 base-stroke",
    x: 320.62,
    y: 193.13,
    width: 31.29,
    height: 46.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "team2 base-stroke",
    x: 234.86,
    y: 53.7,
    width: 31.29,
    height: 46.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "team2 base-stroke",
    x: 234.86,
    y: 100.17,
    width: 31.29,
    height: 46.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "team2 base-stroke",
    x: 234.86,
    y: 146.68,
    width: 31.29,
    height: 46.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "team2 base-stroke",
    x: 351.91,
    y: 53.68,
    width: 31.29,
    height: 46.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "team2 base-stroke",
    x: 351.91,
    y: 100.15,
    width: 31.29,
    height: 46.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "team2 base-stroke",
    x: 351.91,
    y: 146.66,
    width: 31.29,
    height: 46.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "team2 base-stroke",
    x: 351.91,
    y: 193.11,
    width: 31.29,
    height: 46.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "team2 base-stroke",
    x: 437.44,
    y: 53.62,
    width: 31.29,
    height: 46.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "team2 base-stroke",
    x: 437.44,
    y: 100.09,
    width: 31.29,
    height: 46.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "team2 base-stroke",
    x: 437.44,
    y: 146.61,
    width: 31.29,
    height: 46.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "team2 base-stroke",
    x: 437.44,
    y: 193.06,
    width: 31.29,
    height: 46.45
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "team3-desks"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "team3 base-stroke",
    x: 470.06,
    y: 86.16,
    width: 31.29,
    height: 46.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "team3 base-stroke",
    x: 470.06,
    y: 132.63,
    width: 31.29,
    height: 46.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "team3 base-stroke",
    x: 552.83,
    y: 86.14,
    width: 31.29,
    height: 46.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "team6 base-stroke",
    x: 552.83,
    y: 132.61,
    width: 31.29,
    height: 46.45
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "team4-desks"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "team4 base-stroke",
    x: 584.12,
    y: 86.12,
    width: 31.29,
    height: 46.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "team4 base-stroke",
    x: 584.12,
    y: 132.59,
    width: 31.29,
    height: 46.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "team4 base-stroke",
    x: 669.6,
    y: 86.16,
    width: 31.29,
    height: 46.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "team4 base-stroke",
    x: 669.6,
    y: 132.63,
    width: 31.29,
    height: 46.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "team4 base-stroke",
    x: 584.12,
    y: 225.55,
    width: 31.29,
    height: 46.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "team4 base-stroke",
    x: 584.12,
    y: 179.1,
    width: 31.29,
    height: 46.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "team4 base-stroke",
    x: 669.6,
    y: 225.59,
    width: 31.29,
    height: 46.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "team4 base-stroke",
    x: 669.6,
    y: 179.14,
    width: 31.29,
    height: 46.45
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "team5-desks"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "none base-stroke",
    x: 700.89,
    y: 86.14,
    width: 31.29,
    height: 46.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "none base-stroke",
    x: 700.89,
    y: 132.61,
    width: 31.29,
    height: 46.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "businessSupport-seat base-stroke",
    x: 700.89,
    y: 179.12,
    width: 31.29,
    height: 46.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "financeTeam-seat base-stroke",
    x: 700.89,
    y: 225.57,
    width: 31.29,
    height: 46.45
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "team6-desks"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "team6 base-stroke",
    x: 470.06,
    y: 179.14,
    width: 31.29,
    height: 46.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "team6 base-stroke",
    x: 469.92,
    y: 225.59,
    width: 31.29,
    height: 46.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "team6 base-stroke",
    x: 552.83,
    y: 179.12,
    width: 31.29,
    height: 46.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "team6 base-stroke",
    x: 552.83,
    y: 225.57,
    width: 31.29,
    height: 46.45
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "team7-desks"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "licensing-team base-stroke",
    x: 127.76,
    y: 252.34,
    width: 31.01,
    height: 44.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "none base-stroke",
    x: 159.04,
    y: 252.34,
    width: 31.01,
    height: 44.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "none base-stroke",
    x: 127.76,
    y: 296.88,
    width: 31.01,
    height: 44.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "none base-stroke",
    x: 159.04,
    y: 296.88,
    width: 31.01,
    height: 44.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "external-affairs-team base-stroke",
    x: 127.76,
    y: 341.36,
    width: 31.01,
    height: 44.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "media-team base-stroke",
    x: 158.9,
    y: 341.36,
    width: 31.01,
    height: 44.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "media-team base-stroke",
    x: 145.73,
    y: 367.87,
    width: 26.22,
    height: 62.15,
    transform: "translate(557.78 240.11) rotate(90)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "team8-desks"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ceo-office base-stroke",
    x: 875.4,
    y: 72.97,
    width: 42.4,
    height: 95.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "executive-office base-stroke",
    x: 474.46,
    y: 379.09,
    width: 26.74,
    height: 45.41,
    transform: "translate(889.62 -86.04) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "senior-exec-office base-stroke",
    x: 578.2,
    y: 379.09,
    width: 26.74,
    height: 45.41,
    transform: "translate(993.36 -189.78) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "meeting-room base-stroke",
    x: 337.4,
    y: 361.87,
    width: 36.3,
    height: 69.41,
    transform: "translate(752.13 41.03) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "meeting-room base-stroke",
    x: 708.42,
    y: 326.86,
    width: 36.03,
    height: 139.27,
    transform: "translate(1122.94 -329.94) rotate(90)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "doors"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "line-stroke",
    x: 288.58,
    y: 339.39,
    width: 1.43,
    height: 23.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "door-stroke",
    d: "M267.16,340.06c-.03.44-.02.69-.02.98,0,11.5,9.35,22.13,20.85,22.13.22,0,.4,0,.58,0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "line-stroke",
    x: 219.95,
    y: 219.46,
    width: 1.43,
    height: 23.78,
    transform: "translate(452.01 10.68) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "door-stroke",
    d: "M231.88,209.21c-.44-.03-.69-.02-.98-.02-11.5,0-22.13,9.35-22.13,20.85,0,.22,0,.4,0,.58"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "line-stroke",
    x: 823.76,
    y: 339.39,
    width: 1.43,
    height: 23.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "door-stroke",
    d: "M802.35,340.06c-.03.44-.02.69-.02.98,0,11.5,9.35,22.13,20.85,22.13.22,0,.4,0,.58,0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "line-stroke",
    x: 818.58,
    y: 170.6,
    width: 2.03,
    height: 33.63,
    transform: "translate(632.18 1007.01) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "door-stroke",
    d: "M803.72,218.72c.63.04.98.03,1.39.03,16.27,0,31.3-13.23,31.3-29.5,0-.31,0-.56-.01-.83"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "line-stroke",
    x: 301.5,
    y: 339.39,
    width: 1.43,
    height: 23.78,
    transform: "translate(604.43 702.56) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "door-stroke",
    d: "M325.01,340.06c.03.44.02.69.02.98,0,11.5-9.64,22.13-21.5,22.13-.22,0-.41,0-.6,0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "line-stroke",
    x: 220.28,
    y: 284.58,
    width: 1.43,
    height: 23.78,
    transform: "translate(-75.47 517.47) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "door-stroke",
    d: "M232.22,319.27c-.44.03-.69.02-.98.02-11.5,0-22.13-9.64-22.13-21.5,0-.22,0-.41,0-.6"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "line-stroke",
    x: 420.29,
    y: 339.73,
    width: 1.41,
    height: 23.78,
    transform: "translate(842 703.23) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "door-stroke",
    d: "M443.47,340.4c.03.44.02.69.02.98,0,11.5-9.5,22.13-21.19,22.13-.22,0-.4,0-.59,0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "line-stroke",
    x: 524.05,
    y: 339.73,
    width: 1.41,
    height: 23.78,
    transform: "translate(1049.52 703.23) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "door-stroke",
    d: "M547.23,340.4c.03.44.02.69.02.98,0,11.5-9.5,22.13-21.19,22.13-.22,0-.4,0-.59,0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "line-stroke",
    x: 626.54,
    y: 339.73,
    width: 1.41,
    height: 23.78,
    transform: "translate(1254.5 703.23) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "door-stroke",
    d: "M649.72,340.4c.03.44.02.69.02.98,0,11.5-9.5,22.13-21.19,22.13-.22,0-.4,0-.59,0"
  })))), "\uAC00  \n\n  ", _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "room-labels"
  }, /*#__PURE__*/React.createElement("text", {
    className: "room-label",
    transform: "translate(669.6 351.28)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uB300\uD68C\uC758\uC2E4")), /*#__PURE__*/React.createElement("text", {
    className: "room-label",
    transform: "translate(572.65 351.28)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC804\uBB34\uC774\uC0AC\uC2E4")), /*#__PURE__*/React.createElement("text", {
    className: "room-label",
    transform: "translate(470.09 351.28)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC0C1\uBB34\uC774\uC0AC\uC2E4")), /*#__PURE__*/React.createElement("text", {
    className: "room-label",
    transform: "translate(375.32 351.28)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uC18C\uD68C\uC758\uC2E4")), /*#__PURE__*/React.createElement("text", {
    className: "room-label",
    transform: "translate(389.64 135.84)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "room-label",
    transform: "translate(395.44 200.61)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "room-label",
    transform: "translate(886.21 188.43)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CEO\uC2E4")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullLayout);
export default __webpack_public_path__ + "static/media/fullLayout.8413c8b95c65d6a87b8cab9851f35558.svg";
export { ForwardRef as ReactComponent };